import { Figure as FigureCore } from '@studiometa/ui';

/**
 * Figure
 */
export default class Figure extends FigureCore {
  static config = {
    ...FigureCore.config,
  };

  /**
   * mounted hook
   */
  mounted() {
    const { img } = this.$refs;

    if (!img) {
      throw new Error('[Figure] The `img` ref is required.');
    }

    if (!(img instanceof HTMLImageElement)) {
      throw new Error('[Figure] The `img` ref must be an `<img>` element.');
    }

    const { src } = img.dataset;

    if (this.$options.lazy && src && src !== this.src) {
      let tempImg = new Image();
      tempImg.addEventListener(
        'load',
        async () => {
          this.src = src;
          tempImg = null;
          this.enter();
          this.$el.classList.add('is-loaded');
        },
        { once: true },
      );
      tempImg.src = src;

      this.$terminate();
    }
  }
}
